import * as React from "react";
import { ReactElement } from "react";
import { isPlayingDescriptionType } from "../../../../system/AppState/AppStateTrainingCenter";
import { If } from "../../../Generic/If";
import { IsDefined } from "../../../Generic/IsDefined";
import { ImageWithLoadingPlaceholder } from "../../ImageWithLoadingPlaceholder";

export interface FullDescriptionProps {
  title?: string | JSX.Element[];
  subtitle?: string | JSX.Element[];
  text?: string | JSX.Element[];
  imageUrl?: string;
  imageDescription?: string;
  speechFiles: {
    titleSpeechAudioFileUrl?: string;
    titleSpeechMarksFileUrl?: string;
    subtitleSpeechAudioFileUrl?: string;
    subtitleSpeechMarksFileUrl?: string;
    textSpeechAudioFileUrl?: string;
    textSpeechMarksFileUrl?: string;
  };
  isPlaying: isPlayingDescriptionType;
  onAudioEnded: () => void;
}

const FullDescription = React.memo(
  React.forwardRef(function FullDescription(
    props: FullDescriptionProps,
    currentAudioRef: React.Ref<HTMLAudioElement>
  ): ReactElement {
    return (
      <div className="FullDescription">
        <If condition={props.title !== undefined}>
          <div className="FullDescription__title">{props.title}</div>
        </If>
        <If condition={props.subtitle !== undefined}>
          <div className="FullDescription__subtitle">{props.subtitle}</div>
        </If>
        <If condition={props.text !== undefined}>
          <div className="FullDescription__text">{props.text}</div>
        </If>
        <IsDefined value={props.imageUrl}>
          {(image) => (
            <>
              <ImageWithLoadingPlaceholder
                className="FullDescription__image"
                placeholderHeight={220}
                alt="Full description"
                src={image}
              />
              <If condition={props.imageDescription !== undefined && props.imageDescription !== ""}>
                <div className="FullDescription__imageDescription">{props.imageDescription}</div>
              </If>
            </>
          )}
        </IsDefined>
        <IsDefined value={props.speechFiles.titleSpeechAudioFileUrl}>
          {(titleSpeechAudioFileUrl) => (
            <>
              {props.isPlaying === "title" ? (
                <audio
                  ref={currentAudioRef}
                  autoPlay={true}
                  src={titleSpeechAudioFileUrl}
                  onEnded={props.onAudioEnded}
                />
              ) : (
                <></>
              )}
            </>
          )}
        </IsDefined>
        <IsDefined value={props.speechFiles.subtitleSpeechAudioFileUrl}>
          {(subtitleSpeechAudioFileUrl) => (
            <>
              {props.isPlaying === "subtitle" ? (
                <audio
                  ref={currentAudioRef}
                  autoPlay={true}
                  src={subtitleSpeechAudioFileUrl}
                  onEnded={props.onAudioEnded}
                />
              ) : (
                <></>
              )}
            </>
          )}
        </IsDefined>
        <IsDefined value={props.speechFiles.textSpeechAudioFileUrl}>
          {(textSpeechAudioFileUrl) => (
            <>
              {props.isPlaying === "text" ? (
                <audio
                  ref={currentAudioRef}
                  autoPlay={true}
                  src={textSpeechAudioFileUrl}
                  onEnded={props.onAudioEnded}
                />
              ) : (
                <></>
              )}
            </>
          )}
        </IsDefined>
      </div>
    );
  })
);

export default FullDescription;
